import _default from './Advertisement';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Advertisement/index.js
// module id = 2758
// module chunks = 1